module.exports = __webpack_public_path__ + "static/img/two.ba17004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/two.png
// module id = 50rG
// module chunks = 1